import { ElementType } from 'react';

import { useUnreadStore } from '../../../../store';
import { SidebarNavLink } from '../SidebarNavLink';

interface DoBoxNavLinkProps {
  icon: ElementType;
  text: string;
  href?: string;
  isOpen: boolean;
  onNavigate?: () => void;
  dataTestId?: string;
}
export const DoBoxNavLink = ({
  icon,
  text,
  href = '#',
  isOpen,
  onNavigate,
  dataTestId,
}: DoBoxNavLinkProps) => {
  const { getDoboxCount } = useUnreadStore();
  return (
    <SidebarNavLink
      icon={icon}
      text={text}
      href={href}
      isOpen={isOpen}
      count={getDoboxCount()}
      onNavigate={onNavigate}
      dataTestId={dataTestId}
    />
  );
};
